<template>
  <div class="dash-card room-availability-widget">
    <div class="dash-card-header">
      <h3 class="dash-card-title">
        <span
          class="dash-card-title-icon"
          style="background: #e6f7ff; color: #1890ff"
        >
          <a-icon type="bank" />
        </span>
        {{ $t("accueil.dashboard.roomsAvailability") }}
      </h3>
      <div class="room-legend">
        <span><i class="room-dot room-dot--free" />{{ $t("accueil.dashboard.free") }}</span>
        <span><i class="room-dot room-dot--occupied" />{{ $t("accueil.dashboard.occupied") }}</span>
      </div>
    </div>

    <div class="dash-card-body">
      <div v-if="rooms.length" class="rooms-grid">
        <div
          v-for="room in rooms"
          :key="room._id"
          class="room-tile"
          :class="room.status === 'free' ? 'is-free' : 'is-occupied'"
          :title="room.name"
        >
          <span class="room-name">{{ room.name }}</span>
          <span class="room-capacity">
            <a-icon type="team" /> {{ room.capacity }}
          </span>
        </div>
      </div>
      <div v-else class="dash-empty-state">
        <div class="dash-empty-icon">
          <a-icon type="bank" />
        </div>
        <div>{{ $t("accueil.dashboard.noRooms") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoomAvailabilityWidget",
  props: {
    rooms: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.room-legend {
  display: flex;
  gap: 14px;
  font-size: 0.72rem;
  color: #8c8c8c;

  span {
    display: flex;
    align-items: center;
    gap: 5px;
  }
}

.room-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;

  &--free {
    background: var(--dash-info);
  }
  &--occupied {
    background: var(--dash-warning);
  }
}

.rooms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(78px, 1fr));
  gap: 10px;
}

.room-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 14px 6px;
  border-radius: 12px;
  font-weight: 700;
  transition: transform 0.18s ease;
  cursor: default;

  &:hover {
    transform: translateY(-2px);
  }

  &.is-free {
    background: #e6f7ff;
    color: #1890ff;
  }

  &.is-occupied {
    background: #fff7e6;
    color: #d46b08;
  }
}

.room-name {
  font-size: 0.85rem;
}

.room-capacity {
  font-size: 0.62rem;
  font-weight: 600;
  opacity: 0.75;
  display: flex;
  align-items: center;
  gap: 3px;
}

[data-kit-theme="dark"] {
  .room-tile {
    &.is-free {
      background: rgba(24, 144, 255, 0.18);
    }

    &.is-occupied {
      background: rgba(250, 140, 22, 0.18);
    }
  }
}
</style>
